import { Flex } from '@/components/base';
import TicketLabel from '@/features/Commons/Ticket/TicketLabel';
import { SourceLabel } from '@/features/Feedback/components/SourceLabel/SourceLabel';
import useColor from '@/hooks/domain/useColor';
import useDetailModalStore from '@/stores/pure/DetailModalStore';

import { FeedbackViewSizeToggleActions } from './Actions/FeedbackViewSizeToggleActions';

type Props = {
  closeModal: () => void;
  detail: FeedbackT;
};

const FeedbackDetailModalActions = (props: Props) => {
  const color = useColor();

  const checkModalstack = useDetailModalStore((state) => state.checkModalstack);

  return (
    <>
      <Flex
        j="space-between"
        a="center"
        g="8px"
        style={{ fontSize: 20, color: color.gray600 }}
      >
        {!checkModalstack() && <FeedbackViewSizeToggleActions />}
        <Flex a="center" g="6px">
          <SourceLabel {...props.detail?.source} />
          <TicketLabel type="feedback">{props.detail?.tid || '-'}</TicketLabel>
        </Flex>
      </Flex>
    </>
  );
};

export default FeedbackDetailModalActions;
